import React from 'react';
import Progress from '@mui/material/LinearProgress';

const LinearProgress = (props: any) => {
  return (
    <Progress
      {...props}
      sx={{
        background: '#183047',
        '& .MuiLinearProgress-barColorPrimary': {
          background: '#39B3EA',
        },
      }}
    />
  );
};

export default LinearProgress;
